import { __rest } from "tslib";
import React from 'react';
import VeltTranscriptionEmbedModeWireframe from './VeltTranscriptionEmbedModeWireframe/VeltTranscriptionEmbedModeWireframe';
import VeltTranscriptionFloatingModeWireframe from './VeltTranscriptionFloatingModeWireframe/VeltTranscriptionFloatingModeWireframe';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltTranscriptionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltTranscriptionWireframe.EmbedMode = VeltTranscriptionEmbedModeWireframe;
VeltTranscriptionWireframe.FloatingMode = VeltTranscriptionFloatingModeWireframe;
export default VeltTranscriptionWireframe;
